var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    [
      _vm._t("actions"),
      !_vm.noDefaultActions && !_vm.hideBtnEdit
        ? _c("ButtonsEditIcon", {
            on: {
              clicked: function ($event) {
                return _setup.emit("clickedEditButton")
              },
            },
          })
        : _vm._e(),
      !_vm.noDefaultActions && !_vm.hideBtnDelete
        ? _c("ButtonsDeleteIcon", {
            on: {
              clicked: function ($event) {
                return _setup.emit("clickedDeleteButton")
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }